import { Component, Input } from '@angular/core';
import { BaseComponent } from '@m4u-angular/base/component/BaseComponent';
import { ServiceBagServices, ServiceBagService } from '@m4u-angular/base/component/ServiceBag';
import { BaseState } from '@m4u-angular/base/entities/BaseEntities';
import { SidebarService } from '@m4u-angular/core/framework/sidebar.service';
import { EnumFilterPanelActions } from '@m4u-angular/core/framework/sysenums.enum';
import { BottomSheetDialogComponent } from '@m4u-angular/ui/dialogs/bottom-sheet-dialog/bottom-sheet-dialog.component';

@Component({
    providers: ServiceBagServices,
    selector: 'app-page-filter',
    templateUrl: './page-filter.component.html',
    styleUrls: ['./page-filter.component.scss']
})
export class PageFilterComponent extends BaseComponent<BaseState> {
    @Input() DisableApply = false;
    @Input() Context: BottomSheetDialogComponent;

    constructor(A: ServiceBagService,
        private sidebarService: SidebarService) {
        super(A, 'PageFilterComponent', BaseState);
    }

    ApplyFilter() {
        if (this.DisableApply) return;
        this.A.SysEvents.FilterPanelAction(EnumFilterPanelActions.Apply);
        this.sidebarService.Hide('Filters');
        this.Context && this.Context.CloseDialogWithSuccess();
    }

    ClearFilter() {
        this.A.SysEvents.FilterPanelAction(EnumFilterPanelActions.Clear);
        this.sidebarService.Hide('Filters');
        this.Context && this.Context.CloseDialogWithSuccess();
    }

    HasContent(content: any) {
        return content && content.childElementCount > 0;
    }

}
